<template>
  <body class="widget-box" style="height: 100vh !important;" id="changeBody">
    <!-- スカウトパーツ START -->
    <template v-if="tempScout&&!isScoutFinished">
      <template v-if="tempScout.scout_data.category != 0">
        <template v-if="tempScout.scout_data&&!isScoutFinished">
          <!-- バナー -->
          <template v-if="tempScout.scout_data.type==0">
            <BannerScout
              :tempScout="tempScout"
              :tempStory="tempStory"
              :tempChatbot="tempChatbot"
              :widgetData="widgetData"
              :data="data"
              :isSendingEmail="isSendingEmail"
              :sendSeekerReplyDone="sendSeekerReplyDone"
              @closeScout="closeScout"
              @sendSeekerReply="sendSeekerReply"
              @sendEmail="sendEmail"
              @closeScoutSended="closeScoutSended"
              @clickedContent="clickedContent"
              @isBannerDetail="isBannerDetail"
            />
          </template>
          <!-- インタースティシャル -->
          <template v-if="tempScout.scout_data.type == 1">
            <div class="modal-mask" @click="closeScout()"></div>
            <InterstitialScout
              :tempScout="tempScout"
              :tempStory="tempStory"
              :tempChatbot="tempChatbot"
              :widgetData="widgetData"
              :data="data"
              :isSendingEmail="isSendingEmail"
              :sendSeekerReplyDone="sendSeekerReplyDone"
              @closeScout="closeScout"
              @sendSeekerReply="sendSeekerReply"
              @sendEmail="sendEmail"
              @closeScoutSended="closeScoutSended"
              @clickedContent="clickedContent"
            />
          </template>
          <!-- フッター -->
          <template v-if="tempScout.scout_data.type == 2">
            <div class="modal-mask"></div>
            <FooterScout
              :tempScout="tempScout"
              :tempStory="tempStory"
              :tempChatbot="tempChatbot"
              :widgetData="widgetData"
              :data="data"
              :isSendingEmail="isSendingEmail"
              :sendSeekerReplyDone="sendSeekerReplyDone"
              @closeScout="closeScout"
              @sendSeekerReply="sendSeekerReply"
              @sendEmail="sendEmail"
              @closeScoutSended="closeScoutSended"
              @clickedContent="clickedContent"
            />
          </template>
        </template>
      </template>
    </template>
    <!-- スカウトパーツ END   -->
    <!-- ボタン -->
    <transition name="icon">
      <div class="button-location"
          id="changeButton"
          v-if="showModalStatus === 0 && isLoaded && isScoutFlg()"
          :class="[getAnimation(color.animationType), {'minimized-icon': minimized}]"
          :style="[getAppIconStyle(color), getOffsetForButton(color)]">
        <!-- ボタンエフェクト -->
        <span
          class="back-ring"
          id="changeButtonBack"
          v-if="showModalStatus === 0 && color.animationType==1 && isLoaded"
          :style="{
            'background': color.iconBg + '!important',
            'border-radius': color.iconRadius,
            'height': !h ? color.iconHeight : h,
            'width':  !w ? color.iconWidth  : w,
            }">
        </span>
        <!-- 読み込み後 -->
        <a class="button-widget"
          :class="getIcon(color.template - 1)"
          :style="getAppIconStyle(color)"
          @click="clickModal(); $store.dispatch('directtalk/setWDTSeeker', 0)">
          <img
            :style="{
            'border-radius': color.iconRadius,
            'height': !h ? color.iconHeight : h,
            'width':  !w ? color.iconWidth  : w
            }"
            :src="color.iconImage"
            v-if="color.template===10">
          <div
          class="custom-icon-message"
          :class="{
            'left-4px': color.customMsg !='' && color.template != 10,
            '-custom-true': color.template == 10
            }"
          :style="{'border-radius': color.iconRadius,}">
            <span v-if="color.template != 10">{{color.customMsg}}</span>
          </div>
        </a>
        <!-- 読み込み前 -->
        <p class="badge new-message"
          style="min-width: 24px; min-height: 24px;"
          :style="{ 'height': badgeSize(0.2),
                    'width': badgeSize(0.2)}"
          @click="clickModal();$store.dispatch('directtalk/setWDTSeeker', 0)"
          v-if="(widgetData.newMsgCount > 0 || widgetData.newMsgCountBot > 0 || num > 0) > 0 && showModalStatus === 0 && color.badgeType!=0">
          <span class="inner -center"
          style="min-width: 24px; min-height: 24px; margin: auto;"
          :style="{ 'height': badgeSize(0.2),
                    'width': badgeSize(0.2),
                    'font-size': badgeSize(0.15)}"
          >{{ (widgetData.newMsgCountBot + widgetData.newMsgCount + num) > 50 ? '50+' : (widgetData.newMsgCountBot + widgetData.newMsgCount + num) }}</span>
        </p>
      </div>
    </transition>
    <!-- 最小化ボタン -->
    <div v-if="color.showMinimizeButton && showModalStatus === 0 && isLoaded && isScoutFlg()"
    :class="'icon-button'" @click="setMinimize(!minimized)">
      <span class="mdi mdi-24px"
      :class="{'mdi-plus-circle-outline': minimized, 'mdi-minus-circle-outline': !minimized}"
      :style="'color:' + color.iconBg"></span>
    </div>
    <transition name="icon">
      <!-- チャット前 メニュー + チャット画面 -->
      <Dialog
        v-if="showModalStatus > 0"
        :showModalStatus="showModalStatus"
        :scenario="scenario"
        :minipk="minipk"
        :data="data"
        :seeker="seeker"
        :target="target"
        :targetID="targetID"
        :targetIcon="targetIcon"
        :targetModel="targetModel"
        :widgetData="widgetData"
        :color="color"
        :selectTagNewMsg="selectTagNewMsg"
        @changeModalDialog="changeModalDialog"
        @backModal="backModal"
        @close="closeModal"/>
    </transition>
  </body>
</template>

<script>
import { mapState }            from 'vuex'
import moment                  from 'moment'
import isJSON                  from '@/functions/isJSON'
import Dialog                  from '@/views/ChatWidget/Dialog'
import getIcon                 from '@/functions/getIcon'
import getAnimation            from '@/functions/getAnimation'
import watchScenarioMixin from '@/mixins/watchScenarioMixin'
import BannerScout             from '@/components/ChatWidgetDialog/organisms/BannerScout'
import InterstitialScout       from '@/components/ChatWidgetDialog/organisms/InterstitialScout'
import FooterScout             from '@/components/ChatWidgetDialog/organisms/FooterScout'
import resetLocalStorageSeeker from '@/functions/resetLocalStorageSeeker'
export default {
  components: {
    Dialog,
    BannerScout,
    FooterScout,
    InterstitialScout
  },
  mixins: [watchScenarioMixin],
  data () {
    return {
      showModalStatus: 0, // 0: 非表示, 1: menu, 2: 会話
      viewType: 1,
      botid: null,
      isDemo: false,
      weekday: [
        '日', '月', '火', '水', '木', '金', '土'
      ],
      menuActive: false,
      origin: null,
      source: null,
      once: true,
      Logs: [],
      num: 0,
      open: true,
      iconNum: 0,
      msgWait: 3000,
      isGetScenarioTable: false,
      isGetMessage: false,
      isOnly: false,
      cbName: '',
      botIndex: null,
      scnNameTemp: null,
      clickCount: 0,
      intervalId: undefined,
      tranName: '',
      isStaffStart: false,
      isScoutFinished: false,
      tempScout: null,
      tempStory: null,
      tempChatbot: null,
      w: null,
      h: null,
      sendSeekerReplyDone: false,
      now: performance.now(),
      widgetEvent: null,
      minimized: false,
      intervalCount: 0,
    }
  },
  computed: {
    ...mapState('directtalk', ['seeker', 'data', 'widgetData', 'isMessageError', 'color', 'power', 'ws', 'own', 'targetID', 'target', 'targetModel', 'targetIcon', 'isReconnect', 'chatLogs', 'chatTalkHistory', 'isLoaded', 'isSendingEmail', 'isSendedSeeker', 'seekerSync', 'selectTagNewMsg']),
    ...mapState('chatbot', ['scenario', 'scenarioTemp', 'isAutomatic', 'minipk']),
    ...mapState('calendar', ['recommendDate', 'preserveSuggestedSchedulesList'])
  },
  beforeDestroy () {
    clearInterval(this.intervalId)
    window.removeEventListener("beforeunload", this.closeWindow)
    if (localStorage.getItem('MSG_' + this.seeker.id)) {
      localStorage.removeItem('MSG_' + this.seeker.id)
    }
    if (localStorage.getItem('ICON')) {
      localStorage.removeItem('ICON')
    }
  },
  destroyed () {
    if (localStorage.getItem('ICON')) {
      localStorage.removeItem('ICON')
    }
  },
  created () {
    window.addEventListener("beforeunload", this.closeWindow)
    if (localStorage.getItem('ICON')) {
      localStorage.removeItem('ICON')
    }
  },
  mounted () {
    document.addEventListener('visibilitychange', this.handleVisibilityChange, false)
    window.addEventListener('message', (event) => {
      if (event.origin === window.location.origin && window.location.origin === 'http://localhost:8080') return
      this.widgetEvent = event
      this.startWidget()
    }, false)
  },
  watch: {
    isReconnect () {
      if (this.ws == null) {
        // 再接続
        console.log('!!!!!START_再接続します')
        var uri = process.env.WS_ENDPOINT + this.data.ckey + '/' + this.seeker.id + '/'
        this.$store.dispatch('directtalk/connect', {uri: uri, category: 'widget'})
      }
    },
    'seeker.id' () {
      this.$store.dispatch('directtalk/getRoom')
      this.$store.dispatch('directtalk/getReadCount')
    },
    'chatLogs' () {
      if (this.chatLogs) {
        if (this.chatLogs.length > 0) {
          // チャット画面開いているときはカウントしない
          if (!this.chatLogs[this.chatLogs.length - 1].isBot && this.showModalStatus === 0) {
            this.num++
            this.isStaffStart = true
            let nowMessage = localStorage.getItem('MSG_' + this.seeker.id)
            if (nowMessage) {
              let nowMessageParse = JSON.parse(nowMessage)
              nowMessageParse.push({
                msg: this.chatLogs[this.chatLogs.length - 1].message,
                icon: this.chatLogs[this.chatLogs.length - 1].icon,
                image: null
              })
              localStorage.setItem('MSG_' + this.seeker.id, JSON.stringify(nowMessageParse))
            } else {
              localStorage.setItem('MSG_' + this.seeker.id, JSON.stringify([{
                msg: this.chatLogs[this.chatLogs.length - 1].message,
                icon: this.chatLogs[this.chatLogs.length - 1].icon,
                image: null
              }]))
            }
          }
        }
      }
    },
    'power' () {
      if (this.power && this.once && this.widgetData.name.indexOf('訪問者') > -1 && this.data.url.indexOf('localhost') === -1) {
        this.$store.dispatch('auth/slackPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: ''})
        this.$store.dispatch('auth/CWPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: ''})
      }
      this.once = false
    },
    'widgetData.isAuto' () {
      this.appIconScoutProc()
      var uri = process.env.WS_ENDPOINT + this.data.ckey + '/' + this.seeker.id + '/'
      this.$store.dispatch('directtalk/connect', {uri: uri, category: 'widget'})
      for (var i in this.widgetData.bots) {
        var urlAryS = this.widgetData.bots[i].start_url ? this.widgetData.bots[i].start_url.split('|') : []
        for (var j in urlAryS) {
          if (urlAryS[j] === this.data.url) {
            this.botIndex = this.widgetData.bots[i]
            this.scnNameTemp = this.widgetData.bots[i].scenario_name
          }
        }
      }
      if (this.widgetData.isAuto && this.widgetData.bots.length > 0) {
        if (this.botIndex) {
          this.$store.dispatch('chatbot/getScenarioOneTemp', { companyid: this.data.ckey, scenarioName: this.botIndex.scenario_name, node: 'INITIALIZE', rate: this.color.thinking_rate, minipk: this.botIndex.pk ? this.botIndex.pk : null})
        }
      }
    },
    scenarioTemp () {
      this.pushLog(this.scenarioTemp.mainmessage, this.botIndex.icon_data, this.scenarioTemp.image)
    },
    isSendedSeeker () {
      if (this.isSendedSeeker) {
        let sc = this.tempScout
        sc.is_finished = true
        sc.finished_status = 2
        this.$store.dispatch('directtalk/updateScoutHistoryAny', sc)
        this.isScoutFinished = true
        this.tempScout = null
        this.h = null
        this.w = null
        var data = {
          email : this.seekerEmail,
          sessionid: this.seeker.id,
          group: this.data.ckey,
        }
        this.$store.dispatch("directtalk/updateSeekerData", data)
      }
    },
    showModalStatus () {
      this.changeWidgetDialog()
    },
  },
  methods: {
    // 最初のイベント受け取り
    startWidget () {
      if (isJSON(this.widgetEvent.data)) {
        let jsondata = JSON.parse(this.widgetEvent.data)
        if (jsondata.referrer.indexOf(process.env.LOC_HOST + '/dashboard/directtalk') === -1 && jsondata.url !== null && jsondata.url !== undefined) {
          this.$store.dispatch('directtalk/setJson', jsondata)
        }
      }
    },
    // setJsonが正常に処理され、スカウトかそのままアプリアイコン表示するかの動線
    appIconScoutProc () {
      // dialog design
      // アプリアイコン種類判別して出力
      if (this.data.url.indexOf(process.env.LOC_HOST + '/recruit') >= 0) {
        let iconData = {
          pc_t: '',
          mobile_t: '',
          pc_b: '20px',
          mobile_b: '20px',
          pc_l: '',
          mobile_l: '',
          pc_r: '20px',
          mobile_r: '20px',
          icon_height: this.color.iconHeight,
          icon_width: this.addWidthForButton(this.color.iconWidth),
          timeline_height: '62px',
          timeline_width: '200px'
        }
        this.sendWidget(iconData, this.widgetEvent)
      } else {
        let stylePC = this.calcPositionStyle(
          this.color.pc_vertical_position, this.color.pc_horizontal_position,
          this.color.pc_offset_up, this.color.pc_offset_left)
        let styleMobile = this.calcPositionStyle(
          this.color.mobile_vertical_position, this.color.mobile_horizontal_position,
          this.color.mobile_offset_up, this.color.mobile_offset_left)
        let iconData = {
          pc_t: stylePC.top,
          mobile_t: styleMobile.top,
          pc_b: stylePC.bottom,
          mobile_b: styleMobile.bottom,
          pc_l: stylePC.left,
          mobile_l: styleMobile.left,
          pc_r: stylePC.right,
          mobile_r: styleMobile.right,
          pc_transform: stylePC.translate,
          mobile_transform: styleMobile.translate,
          icon_height: this.color.iconHeight,
          icon_width: this.addWidthForButton(this.color.iconWidth),
          timeline_height: '62px',
          timeline_width: '200px'
        }
        this.sendWidget(iconData, this.widgetEvent)
      }
      this.sendWidget(this.seeker, this.widgetEvent)
      if (this.seeker.scout && this.widgetData.name) {
        this.tempScout = this.seeker.scout
        this.tempStory = this.seeker.story
        this.tempChatbot = this.seeker.chatbot
      } else if (this.widgetData.autoScout) {
        if (this.widgetData.autoScout.isScout && !this.tempScout && !this.isScoutFinished) {
          // 自動スカウト判定
          this.autoScoutInteval()
        }
      }
      this.isScoutFinished = false
      localStorage.setItem('ICON', 'on')
      this.styleChangeWidget()
    },
    styleChangeWidget () {
      setTimeout(() => {
        this.changeWidget()
        this.$forceUpdate()
      }, 1)
    },
    changeWidget () {
      if (this.tempScout) {
        // スカウト一時停止している場合
        if (this.isStopScoutNow()) {
          this.oneDayCloseScout()
        } else if (this.tempScout.scout_data.category === 0 && this.color.iconHeight) {
          this.isScoutFinished = true
          this.sendWidget('onCloseMsg', this.widgetEvent)
          if (this.data.url.indexOf(process.env.LOC_HOST + '/recruit') >= 0) {
            let iconData = {
              pc_t: '',
              mobile_t: '',
              pc_b: '20px',
              mobile_b: '20px',
              pc_l: '',
              mobile_l: '',
              pc_r: '20px',
              mobile_r: '20px',
              icon_height: this.color.iconHeight,
              icon_width: this.addWidthForButton(this.color.iconWidth),
              timeline_height: '62px',
              timeline_width: '200px'
            }
            this.sendWidget(iconData, this.widgetEvent)
          } else {
            this.h = (Number(this.color.iconHeight.replace('px', '')) * 1.3) + 'px'
            this.w = (Number(this.color.iconWidth.replace('px', '')) * 1.3) + 'px'
            let stylePC = this.calcPositionStyle(
              this.color.pc_vertical_position, this.color.pc_horizontal_position,
              this.color.pc_offset_up, this.color.pc_offset_left)
            let styleMobile = this.calcPositionStyle(
              this.color.mobile_vertical_position, this.color.mobile_horizontal_position,
              this.color.mobile_offset_up, this.color.mobile_offset_left)
            let iconData = {
              pc_t: stylePC.top,
              mobile_t: styleMobile.top,
              pc_b: stylePC.bottom,
              mobile_b: styleMobile.bottom,
              pc_l: stylePC.left,
              mobile_l: styleMobile.left,
              pc_r: stylePC.right,
              mobile_r: styleMobile.right,
              pc_transform: stylePC.translate,
              mobile_transform: styleMobile.translate,
              icon_height: this.h,
              icon_width: this.addWidthForButton(this.w),
              timeline_height: '62px',
              timeline_width: '200px'
            }
            this.sendWidget(iconData, this.widgetEvent)
          }
        } else {
          // スカウト表示の画面サイズ倍率
          let disp_width  = Math.floor(300 * this.tempScout.scout_data.disp_size)
          let disp_height = Math.floor(250 * this.tempScout.scout_data.disp_size)
          let iconData ={
            size_set_height: disp_height,
            size_set_width: disp_width
          }
          this.sendWidget(iconData, this.widgetEvent)
          // 画面によって変える
          if (this.tempScout.scout_data.type === 0) {
            // バナー
            if (this.tempScout.scout_data.category === 1 && this.tempScout.scout_data.disp_size === 1) {
              document.getElementById('banner-scout-msg').style.display = "none";
            } else if (this.tempScout.scout_data.category === 1 && this.tempScout.scout_data.disp_size === 1.5) {
              document.getElementById('banner-scout-msg').style.height = (disp_height - 256) + 'px';
            } else if (this.tempScout.scout_data.category === 1 && this.tempScout.scout_data.disp_size === 2) {
              document.getElementById('banner-scout-msg').style.height = (disp_height - 256) + 'px';
            }
            this.sendWidget('onOpenBannar', this.widgetEvent)
          } else if (this.tempScout.scout_data.type === 1) {
            // インタースティシャル
            document.getElementById('interstitial').style.width = disp_width + 'px';
            if (window.outerWidth < 500) {
              document.getElementById('interstitial').style.maxWidth = '320px';
            }
            document.getElementById('interstitial').style.height = disp_height + 'px';
            if (this.tempScout.scout_data.category === 1) {
              // スカウトメッセージ
              document.getElementById('inter-scout').style.width = disp_width + 'px';
              if (window.outerWidth < 500) {
                document.getElementById('inter-scout').style.maxWidth = '320px';
              }
              document.getElementById('inter-scout').style.height = disp_height + 'px';
              if (this.tempScout.scout_data.disp_size === 1) {
                document.getElementById('inter-scout-img').style.height = (120 - 32) + 'px';
                document.getElementById('inter-scout-msg').style.height = (disp_height - 220) + 'px';
                document.getElementById('inter-scout-msg').style.fontSize = 'smaller';
              } else if (this.tempScout.scout_data.disp_size === 1.5) {
                document.getElementById('inter-scout-msg').style.height = (disp_height - 256) + 'px';
              } else if (this.tempScout.scout_data.disp_size === 2) {
                document.getElementById('inter-scout-msg').style.height = (disp_height - 256) + 'px';
              }
            }
            else if ((this.tempScout.scout_data.category === 2 || this.tempScout.scout_data.category == 3)
            && this.widgetData.companyName) {
              // 求人ノベル紹介 or ロボ紹介
              document.getElementById('inter-novel').style.width = disp_width + 'px';
              if (window.outerWidth < 500) {
                document.getElementById('inter-novel').style.maxWidth = '320px';
              }
              document.getElementById('inter-novel').style.height = disp_height + 'px';
            }
            this.sendWidget('onOpenOverRay', this.widgetEvent)
          } else if (this.tempScout.scout_data.type === 2) {
            // フッター
            document.getElementById('footer').style.height = disp_height + 'px';
            if (this.tempScout.scout_data.category === 1) {
              // スカウトメッセージ
              document.getElementById('footer-scout').style.height = disp_height + 'px';
              if (this.tempScout.scout_data.disp_size === 1) {
                document.getElementById('footer-scout-img').style.height = (120 - 32) + 'px';
                document.getElementById('footer-scout-msg').style.height = (disp_height - 208) + 'px';
                document.getElementById('footer-scout-msg').style.fontSize = 'smaller';
              } else if (this.tempScout.scout_data.disp_size === 1.5) {
                document.getElementById('footer-scout-msg').style.height = (disp_height - 256) + 'px';
              } else if (this.tempScout.scout_data.disp_size === 2) {
                document.getElementById('footer-scout-msg').style.height = (disp_height - 256) + 'px';
              }
            }
            else if ((this.tempScout.scout_data.category === 2 || this.tempScout.scout_data.category == 3)
            && this.widgetData.companyName) {
              // 求人ノベル紹介 or ロボ紹介
              document.getElementById('footer-novel').style.height = disp_height + 'px';
            }
            this.sendWidget('onOpenFooter', this.widgetEvent)
          }
        }
      } else if (!this.power) {
        this.sendWidget('powerOff', this.widgetEvent)
      } else if (this.showModalStatus === 0) {
        this.sendWidget('onCloseMsg', this.widgetEvent)
      } else if (this.showModalStatus === 1) {
        if (this.color.view_template === 0) {
          this.sendWidget('onOpen', this.widgetEvent)
        } else {
          this.sendWidget('onOpenSelect', this.widgetEvent)
        }
      } else {
        this.sendWidget('onOpenDialog', this.widgetEvent)
      }
    },
    // アイコン位置の算出
    calcPositionStyle (vertical_position, horizontal_position, offset_up, offset_left) {
      let res = {
        top: '',
        bottom: '',
        left: '',
        right: '',
        translate: ''
      }
      if (!isNaN(offset_up)) offset_up += 'px'
      if (!isNaN(offset_left)) offset_left += 'px'
      if (vertical_position == 'top') {
        // 正負反転
        res.top = (offset_up[0] == '-' ? offset_up.slice(1) : '-'+offset_up)
      }
      else if (vertical_position == 'bottom') {
        res.bottom = offset_up
      }
      else if (vertical_position == 'center') {
        res.top = 'calc(50% - ' + offset_up + ')'
        res.translate += ' translateY(-50%)'
      }
      if (horizontal_position == 'left') {
        // 正負反転
        res.left = (offset_left[0] == '-' ? offset_left.slice(1) : '-'+offset_left)
      }
      else if (horizontal_position == 'right') {
        res.right = offset_left
      }
      else if (horizontal_position == 'center') {
        res.left = 'calc(50% - ' + offset_left + ')'
        res.translate += ' translateX(-50%)'
      }
      return res
    },
    addWidthForButton (base_width) {
      if (this.color.showMinimizeButton) return (Number(base_width.replace('px', '')) + 25) + 'px'
      else return base_width
    },
    // ダイアログに変更あったときに呼び出し
    changeWidgetDialog () {
      if (this.showModalStatus === 0) {
        this.sendWidget('onCloseMsg', this.widgetEvent)
      } else if (this.showModalStatus === 1) {
        if (this.color.view_template === 0) {
          this.sendWidget('onOpen', this.widgetEvent)
        } else {
          this.sendWidget('onOpenSelect', this.widgetEvent)
        }
      } else {
        this.sendWidget('onOpenDialog', this.widgetEvent)
      }
    },
    // 終了時処理
    closeWindow () {
      let tid = 'no target'
      let sid = 'no element'
      if (this.targetID) {
        if (this.targetID.length > 0) {
          tid = this.targetID
        }
      }
      if (this.scenario) {
        if (this.scenario.beforenode) {
          if (this.scenario.beforenode.length > 0) {
            sid = this.scenario.beforenode
          }
        }
      }
      this.$store.dispatch('directtalk/createSeekerATHistory', {target: tid, action: 'browser_close', url: this.data.url, element: sid})
    },
    sendWidget (data, event) {
      this.widgetEvent.source.postMessage(data, this.widgetEvent.origin)
    },
    autoScoutInteval () {
      this.intervalId = setInterval(() => {
        if (this.intervalCount > 5) {
          clearInterval(this.intervalId)
        }
        this.intervalCount++

        if (this.needsScout(this.widgetData.autoScout)) {
          let schisTemp = {
            seeker: this.seeker.pk,
            scout: this.widgetData.autoScout.scout.pk,
            is_finished: false,
            finished_status: 0
          }
          this.$store.dispatch('directtalk/createScoutHistoryAny', schisTemp)
            .then((d) => {
              this.tempScout = JSON.parse(d.scout)
              this.tempStory = JSON.parse(d.story)
              this.tempChatbot = JSON.parse(d.chatbot)
              this.styleChangeWidget()
              clearInterval(this.intervalId)
            })
        }
      }, 50)
    },
    isScoutFlg () {
      if (this.tempScout) {
        if (this.tempScout.scout_data.category == 0) return true
        else return false
      } else {
        return true
      }
    },
    closeScout () {
      let sc = this.tempScout
      sc.is_finished = true
      sc.finished_status = 1
      this.$store.dispatch('directtalk/updateScoutHistoryAny', sc)
      this.isScoutFinished = true
      this.tempScout = null
      this.h = null
      this.w = null
      this.styleChangeWidget()
    },
    oneDayCloseScout () {
      let sc = this.tempScout
      sc.is_finished = false
      sc.finished_status = 1
      this.$store.dispatch('directtalk/updateScoutHistoryAny', sc)
      this.isScoutFinished = true
      this.tempScout = null
      this.h = null
      this.w = null
      this.styleChangeWidget()
    },
    scoutSuccess () {
      let sc = this.tempScout
      sc.is_finished = true
      sc.finished_status = 2
      this.$store.dispatch('directtalk/updateScoutHistoryAny', sc)
      this.styleChangeWidget()
    },
    closeScoutSended () {
      this.isScoutFinished = true
      this.tempScout = null
      this.h = null
      this.w = null
      this.styleChangeWidget()
    },
    clickedContent () {
      let sc = this.tempScout
      sc.is_finished = true
      sc.finished_status = 2
      this.$store.dispatch('directtalk/updateScoutHistoryAny', sc)
      this.isScoutFinished = true
      this.tempScout = null
      this.h = null
      this.w = null
      this.styleChangeWidget()
    },
    sendEmail (seekerEmail) {
      var text = '<br/>' + seekerEmail + '様<br/><br/>'
      text += 'この度はスカウト登録いただきありがとうございます。<br/>'
      text += '弊社の情報を本Emailを通してお送りできたらと考えております。<br/>'
      text += 'また、弊社の採用に関することで気になる点ございましたら、<br/>'
      text += 'お気軽にご連絡いただけますと幸いでございます。<br/><br/>'
      text += '--------------------------------------------------<br/>'
      text += this.tempScout.scout_data.name + '<br/><br/>'
      text += this.tempScout.scout_data.content.replace(/\r?\n/g, '<br/>') + '<br/>'
      text += '--------------------------------------------------<br/>'
      text += this.widgetData.companyName + ' 採用担当'
      // 応募者管理画面からのメール送信時にメール内容を確認する画面が追加されている為、
      // SendEmailToSeekerViewからメール送信する際はconfirmFlgも含めて渡すこと
      let tempEmail = {
        from_email: this.widgetData.companyEmail,
        to_email: seekerEmail,
        cc_email: this.widgetData.companyEmail,
        title: '閲覧企業からスカウトが届いております。（' + this.widgetData.companyName + '）',
        template: text,
        confirmFlg: 0,
      }
      const updateData = {
        email: seekerEmail,
        is_subscribe: true,
        subscribe_date: new Date(),
        subscribe_count: 1,
        recruit_route: 'スカウト返信者',
        sessionid: this.seeker.id,
        group: this.data.ckey,
      }
      this.$store.dispatch('directtalk/updateSeekerData', updateData)
      tempEmail.seeker = this.seeker.pk
      this.$store.dispatch('directtalk/sendEmailToSeeker', tempEmail)
        .then(() => {
          alert('送付完了いたしました。')
        })
        .catch(() => {
          alert('メール送付中にエラーが発生いたしました。')
        })
      this.styleChangeWidget()
    },
    pushLog (msg, icon, image) {
      this.num += 1
    },
    closeModal (num) {
      this.showModalStatus = 0
      this.$store.dispatch('directtalk/setWDTSeeker', num)
    },
    backModal () {
      this.showModalStatus = 1
    },
    changeModalDialog () {
      this.showModalStatus = 2
    },
    menuToggle () {
      this.menuActive = !this.menuActive
    },
    openChatBot (b, idx) {
      if (this.targetID !== b.bot_id) {
        this.bot = b
        this.$store.dispatch('directtalk/setDT', {name: b.display_name, icon: b.icon_data, id: b.bot_id, model: 'bot'})
        this.$store.dispatch('chatbot/setMiniPK', b.pk || null)
        this.$store.dispatch('directtalk/createSeekerATHistory', {target: b.display_name, action: 'click_room', url: this.data.url, element: 'button'})
        this.createSKTagHistory('click_room', b.tag)
        let id = b.pk || b.bot_id
        let lv = localStorage.getItem('scenariolv_' + id)
        if (lv) {
          lv = JSON.parse(lv)
          if (lv.node == '') {
            lv = null
            localStorage.removeItem('scenariolv_' + id)
          }
        }
        if (!lv) {
          resetLocalStorageSeeker(this.seeker.id)
          this.$store.dispatch('chatbot/getScenarioOne', { companyid: this.data.ckey, scenarioName: b.scenario_name, node: 'INITIALIZE', rate: this.color.thinking_rate, minipk: this.bot.pk ? this.bot.pk : null})
        }
        this.$store.commit('chatbot/SET_LAST_VIEW', lv)

      } else {
        this.$store.dispatch('directtalk/setDT', {name: b.display_name, icon: b.icon_data, id: b.bot_id, model: 'bot'})
        this.$store.dispatch('chatbot/setMiniPK', b.pk || null)
        this.$store.dispatch('directtalk/createSeekerATHistory', {target: b.display_name, action: 'click_room', url: this.data.url, element: 'button'})
        this.createSKTagHistory('click_room', b.tag)
      }
    },
    openDirectTalk (u) {
      this.$store.dispatch('directtalk/setDT', {name: u.username, icon: u.icon, id: u.userID, model: 'user'})
      this.$store.dispatch('directtalk/createSeekerATHistory', {target: 'none', action: 'click_room', url: this.data.url, element: 'button'})
    },
    createSKTagHistory (action_name, tag) {
      let tempSeekerTagHistory = {
        seeker: this.seeker.pk,
        action_name: 'click_room',
        url: this.data.url,
        tag: tag
      }
      this.$store.dispatch('directtalk/createSeekerTagHistory', tempSeekerTagHistory)
    },
    clickModal () {
      var body = document.getElementById('changeBody')
      this.clickCount = 1
      body.style.opacity = '0'
      body.style.transform = 'scale(0)'
      var btn = document.getElementById('changeButton')
      btn.style.transistionDuration = '1s'
      btn.style.opacity = '1'
      btn.style.transform = 'scale(1)'
      if (this.color.animationType == 1) {
        console.info('color.animationType is not zero')
        var backbtn = document.getElementById('changeButtonBack')
        backbtn.style.opacity = '0'
        backbtn.style.transform = 'scale(0)'
      }
      setTimeout(() => {
        body.style.opacity = '1'
        body.style.transform = 'scale(1)'
        btn.style.opacity = '0'
        btn.style.transform = 'scale(0)'
        if (this.color.animationType == 1) {
          console.info('color.animationType is not zero')
          backbtn.style.opacity = '1'
          backbtn.style.transform = 'scale(1)'
        }
      }, 200)
      if (this.tempScout) {
        let sc = this.tempScout
        sc.is_finished = true
        sc.finished_status = 2
        this.$store.dispatch('directtalk/updateScoutHistoryAny', sc)
        this.isScoutFinished = true
        this.tempScout = null
        this.h = null
        this.w = null
      }
      this.$store.dispatch('directtalk/setWidgetReceive', this.num)
      this.num = 0
      this.$store.dispatch('directtalk/createSeekerATHistory', {target: 'none', action: 'click_icon', url: this.data.url, element: 'button'})
      // タグ履歴作成
      this.createSKTagHistory('click_icon', this.widgetData.tags)
      // 選択画面表示無しの場合 もしくは 最初にスタッフが話しかけた場合
      if (this.color.view_template == 2 || this.isStaffStart) {
        var b = null
        var idx = -1
        // 最初にスタッフが話しかけた場合はそのままダイレクトトークへ
        if (this.isStaffStart) {
          this.isStaffStart = false
          this.openDirectTalk(this.widgetData.users[0])
        // ロボが存在しない場合はダイレクトトークへ
        } else if (this.widgetData.bots.length == 0) {
          this.openDirectTalk(this.widgetData.users[0])
        } else {
          // 設置されているURLの一番最初のロボを呼び出す。
          for (var i in this.widgetData.bots) {
            var urlAryS = this.widgetData.bots[i].start_url.split('|')
            for (var j in urlAryS) {
              if (urlAryS[j] === this.data.url) {
                idx = i
                b = this.widgetData.bots[i]
              }
            }
            // botが存在する時はStartに設定しているロボへそうでない場合はDTチャットへ
            if (idx !== -1) this.openChatBot(b, idx)
            else if (this.widgetData.bots.length > 0) {
              this.openChatBot(this.widgetData.bots[0], 0)
            } else {
              this.openDirectTalk(this.widgetData.users[0])
            }
          }
        }
        // 直接会話画面へ
        this.showModalStatus = 2
      } else {
        // メニューへ
        this.showModalStatus = 1
      }
      this.$store.dispatch('auth/slackPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: '[icon]'})
      this.$store.dispatch('auth/CWPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: '[icon]'})
    },
    shadowStyle () {
      if (this.color.shadowType === 0) return 'drop-shadow(0px 0px 0px rgba(0,0,0,0.3))'
      else return 'drop-shadow(1px 1px 1px rgba(0,0,0,0.3))'
    },
    getIcon (i) {
      return getIcon(i)
    },
    getAnimation (i) {
      return getAnimation(i)
    },
    badgeSize (i) {
      return Math.floor((Number(this.color.iconHeight.replace('px', '')) > Number(this.color.iconWidth.replace('px', '')) ? Number(this.color.iconWidth.replace('px', '')) : Number(this.color.iconHeight.replace('px', ''))) * i) + 'px'
    },
    sendSeekerReply (info) {
      let seekerInfo = info
      seekerInfo.seeker = this.seeker.pk
      seekerInfo.company_name = this.widgetData.companyName
      seekerInfo.company_email = this.widgetData.companyEmail
      if (this.sendSeekerReplyValidation(seekerInfo)) return
      // 返信内容の入力がない場合は未入力と入力されたことになる
      if (seekerInfo.reply === '') {
        seekerInfo.reply = '未入力'
      }
      this.$store.dispatch('directtalk/sendSeekerReply', seekerInfo)
        .then((d) => {
          this.sendSeekerReplyDone = true
          this.scoutSuccess()
        })
      const updateSeekerInfo = {
        name:  seekerInfo.name,
        email: seekerInfo.user_email,
        is_subscribe: true,
        subscribe_date: new Date(),
        subscribe_count: 1,
        recruit_route: 'スカウト返信者',
        sessionid: this.seeker.id,
        group: this.data.ckey,
      }
      this.$store.dispatch('directtalk/updateSeekerData', updateSeekerInfo)
      this.styleChangeWidget()
    },
    sendSeekerReplyValidation (seekerInfo) {
      // 未入力チェック
      let emptyList = []
      for (const i in seekerInfo) {
        if (seekerInfo[i] === '' && (i == 'name' || i == 'user_email')) {
          emptyList.push(i)
        }
      }
      let alertContent = ''
      for (const item of emptyList) {
        switch (item) {
          case 'name':
            if (alertContent === '') alertContent += '■以下の項目が未入力です\n'
            alertContent += ('・お名前\n')
            break
          case 'user_email':
            if (alertContent === '') alertContent += '■以下の項目が未入力です\n'
            alertContent += ('・Eメールアドレス\n')
            break
        }
      }
      // メールアドレスの形式チェック
      const regexp = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
      if (seekerInfo.user_email !== '' && !regexp.test(seekerInfo.user_email)) {
        if (alertContent === '') alertContent += '■Eメールアドレスの形式が不正です'
        else alertContent += '\n■Eメールアドレスの形式が不正です'
      }
      // アラートの表示
      if (alertContent !== '') {
        alert(alertContent)
        return true
      }
    },
    timer () {
      return Math.floor((performance.now() - this.now) / 1000)
    },
    isStopScoutNow () {
      if (
        localStorage.getItem('SCOUT_STOP_ONEDAY') === 'on'
        &&
        new Date() < new Date(localStorage.getItem('SCOUT_STOP_TIME'))
      ) {
        return true
      } else {
        return false
      }
    },
    needsScout (param) {
      if (!this.seekerSync){
        return false
      }
      if (param.spendTime > this.timer() && param.spendTime > this.getSpendTime(this.seekerSync, 1)) {
        return false
      }
      if (param.segment != this.getFlg(this.seekerSync) && param.segment != 0) {
        return false
      }
      if (param.visitedCount > this.getCount(this.seekerSync, 1)) {
        return false
      }
      if ((param.isConv  && this.seekerSync.conv_count === 0) ||
          (!param.isConv && this.seekerSync.conv_count > 0)
      ) {
        return false
      }
      if (this.isStopScoutNow()) {
        return false
      }
      if (param.scoutPageUrl && this.data.url.indexOf(param.scoutPageUrl) === -1) {
        return false
      }
      return true
    },
    getFlg (sk) {
      if (!sk.seeker_history[0]) {
        return 0
      } else if (sk.seeker_history[0].referrer) {
        if (sk.seeker_history[0].referrer.indexOf('employment.en-japan.com') >= 0 ||
            sk.seeker_history[0].referrer.indexOf('en-gage.net') >= 0 ||
            sk.seeker_history[0].referrer.indexOf('type.jp') >= 0 ||
            sk.seeker_history[0].referrer.indexOf('rikunavi.com') >= 0 ||
            sk.seeker_history[0].referrer.indexOf('mynavi.jp') >= 0
        ) {
          return 2
        } else if (this.getSpendTime(sk, 1) > 300) {
          return 2
        } else if (this.getCount(sk, 1) > 3) {
          return 1
        } else {
          return 0
        }
      } else if (this.getSpendTime(sk, 1) > 300) {
        return 2
      } else if (this.getCount(sk, 1) > 3) {
        return 1
      } else {
        return 0
      }
    },
    getCount (sk, month) {
      var cnt = 0
      for (let h of sk.seeker_history) {
        if (h.created_at) {
          // 当日から1ヶ月前の日付以降ならカウントする
          if (moment(h.created_at) >= moment().subtract(month, 'months')) {
            cnt++
          }
        }
      }
      return cnt
    },
    getSpendTime (sk, month) {
      var cnt = 0
      for (let h of sk.seeker_history) {
        if (h.created_at && h.ended_at) {
          // 当日から1ヶ月前の日付以降ならカウントする
          if (moment(h.created_at) >= moment().subtract(month, 'months')) {
            if (h.created_at && h.ended_at) cnt += moment(h.ended_at).diff(moment(h.created_at), 'seconds')
          }
        }
      }
      return cnt
    },
    getAppIconStyle (color) {
      const width = !this.w ? color.iconWidth  : this.w
      const height = !this.h ? color.iconHeight : this.h
      return {
        'background': color.iconBg + '!important',
        'color': color.iconFr + '!important',
        'border-radius': color.iconRadius ? color.iconRadius : 0,
        'width': width ? width : '80px',
        'height': height ? height : '80px',
        'filter': this.shadowStyle()
      }
    },
    getOffsetForButton (color) {
      if (color.showMinimizeButton) return {'right' : '25px'}
      else return {}
    },
    isBannerDetail () {
      document.getElementById('banner-scout-msg').style.display = "block";
      if (this.tempScout.scout_data.disp_size != 1) {
        document.getElementById('banner-scout-img').style.display = "block";
      }
    },
    setMinimize(state) {
      setTimeout(() => {
        this.minimized = state
      }, 250);
      if (state) this.sendWidget('onMinimize', this.widgetEvent)
      else this.sendWidget('onUndoMinimize', this.widgetEvent)
    }
  },
}
</script>

<style lang="scss">
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
html {
  background-color:transparent !important;
  width: 100%;
  height: 100vh;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  overflow: hidden !important;
  -webkit-text-size-adjust: 100% !important;
  min-width: 0 !important;
}
body {
  background-color:transparent !important;
  position: fixed !important;
  width: 100%;
  height: 100vh !important;
  -webkit-text-size-adjust: 100% !important;
}
body, button, input, select, textarea {
  font-family: 'Noto Sans JP', "Montserrat","游ゴシック",YuGothic,"ヒラギノ角ゴ ProN W3","Hiragino Kaku Gothic ProN","メイリオ",Meiryo,sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html::-webkit-scrollbar{
  display:none;
}
// iframeの大きさの都合で、transform: scale(0.8);する
.button-location {
  position: fixed;
  line-height: 1.65;
  pointer-events: auto !important;
  transform: translate3d(0, 0, 0) scale(0.8);
  z-index: 1;
  margin-top: 4px;
  will-change: transform;
  transition: opacity 0.5s;
}
.back-ring {
  position: fixed;
  animation: pulsate 1s ease-out;
  animation-iteration-count: infinite;
  z-index: -1;
  right: 0;
}
@keyframes pulsate {
  0%   { filter: brightness(120%); transform: scale(1); opacity: 0.8;}
  50%  { filter: brightness(150%); opacity: 0.8; }
  100% { filter: brightness(180%); transform: scale(1.2); opacity: 0.0; }
}
.button-widget {
  display: block;
  position: relative;
  z-index: 9999 !important;
  pointer-events: auto !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-widget > img {
  display: block;
  object-fit: cover;
}
.badge {
  display: none;
  position: absolute;
  z-index: 10000;
  right: -4px;
  top: -4px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fff;
  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
}
.badge .inner {
  position: relative;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  color: #fff;
  line-height: 25px;
  margin-left: 2.45px;
  margin-top: 2.85px;
  text-align: center;
  background: -webkit-gradient(linear, left top, left bottom, from(#ee757b), to(#c80507));
  background: -webkit-linear-gradient(top, #ee757b, #c80507);
  background: linear-gradient(to bottom, #ee757b, #c80507);
  background: gradient(linear, center top, center bottom, from(#ee757b), to(#c80507));
}
.inner {
  &.-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media screen and (max-width: 300px) {
  .badge {
    position: fixed;
    z-index: 10000;
    right: -4px;
    top: -4px;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #fff;
    -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
  }
  .badge .inner {
    position: relative;
    width: 23px;
    height: 23px;
    border-radius: 50%;
    color: #fff;
    line-height: 25px;
    margin-left: 1px;
    margin-top: 1.45px;
    text-align: center;
    background: -webkit-gradient(linear, left top, left bottom, from(#ee757b), to(#c80507));
    background: -webkit-linear-gradient(top, #ee757b, #c80507);
    background: linear-gradient(to bottom, #ee757b, #c80507);
    background: gradient(linear, center top, center bottom, from(#ee757b), to(#c80507));
  }
}
.custom-icon-message {
  font-size: large;
  white-space: pre-wrap;
  &.-custom-true{
    position: absolute;
  }
  span {
    font-weight: bold;
  }
}
.left-4px {
  margin-left: 4px;
}

.icon-button {
  position: absolute;
  top: -8px;
  right: -4px;
  width: 36px;
  z-index: 9999;
  cursor: pointer;
  transition: background-color 0.5s;
  border-radius: 50%;
  background: none;
}

.minimized-icon {
  opacity: 0;
}

// * アニメーションについて、表示の都合上、全て、transformに scale(0.8) する必要あり
/* 上下に浮遊 */
.huyuu {
  animation: huwahuwa 2s ease-out;
  animation-iteration-count: infinite;
  z-index: 0;
}
@keyframes huwahuwa {
  0% {
    transform: translateY(0px) scale(0.8);
  }
  50% {
    transform: translateY(-7.5px) scale(0.8);
  }
  100% {
    transform: translateY(0px) scale(0.8);
  }
}
/* ぐるぐる */
.guruguru {
  animation: guruguru 3s ease-out;
  animation-iteration-count: infinite;
  z-index: 0;
}
@keyframes guruguru {
  0% {
    transform: rotateY(0deg) scale(0.8);
  }
  50% {
    transform: rotateY(180deg) scale(0.8);
  }
  100% {
    transform: rotateY(360deg) scale(0.8);
  }
}
/* 拡大・縮小 */
.kakusyuku {
  animation: kakusyuku 3s ease-out;
  animation-iteration-count: infinite;
  z-index: 0;
}
@keyframes kakusyuku {
  0% {
    transform: scale(1.0) scale(0.8);
  }
  50% {
    transform: scale(0.85) scale(0.8);
  }
  100% {
    transform: scale(1.0) scale(0.8);
  }
}
// アイコン表示のアニメ
 .icon-enter-active {
  transition: all 1.0s ease 0s;
 }
 .icon-leave-active {
  transition: all 0.3s ease 0s;
 }
 .icon-enter,
 .icon-leave-to {
  opacity: 0;
 }
 .icon-enter {
  transform: scale(0);
 }
 .icon-enter-to,
 .icon-leave {
  transform: scale(1);
 }
 .icon-leave-to {
  transform: scale(0);
 }
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
}
::-webkit-scrollbar {
    width: 8px;
}
::-webkit-scrollbar-thumb {
    border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/ChatWidget/ChatWidgetDialog.vue